import React, { useContext } from 'react';
import { Button } from 'antd';

import TicketContext from '@totem/components/ticketing/details/ticketContext';
import { TimeEntryCreateExtras } from '@totem/components/ticketing/types';

type Props = {
  extras?: TimeEntryCreateExtras;
};

const ButtonCreateTimeEntry = ({ extras }: Props) => {
  const { onAction } = useContext(TicketContext);
  return (
    <Button
      type="primary"
      onClick={() =>
        onAction(
          'show-time-entry-create',
          extras !== null ? JSON.stringify(extras) : '',
        )
      }
    >
      Add Time Entry
    </Button>
  );
};

export default ButtonCreateTimeEntry;
